export default __webpack_public_path__ + "horizontal-resize-option.png";